import { InputTypes } from 'constants/enums';
import { IEvaluationQuestionType, IFormField, IOption } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { IWorkshopEvaluationQuestionDimension } from 'models/workshopEvaluationQuestionDimension';


interface Props {
  open: boolean;
  loading: boolean;
  types: IEvaluationQuestionType[];
  dimensions: IWorkshopEvaluationQuestionDimension[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const AddWorkshopEvaluationQuestion: React.FC<Props> = ({ open, loading, dimensions, types, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let typesOptions = types.map((type) => {
    return { value: type.id.toString(), label: type.description };
  });

  let dimensionsOptions = dimensions.map((dimension) => {
    return { value: dimension.id, label: dimension.description };
  });

  let basicFields: IFormField[] = [
    {
      name: 'title',
      label: t('T_title'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_title'),
      internalLabel: true,
      required: true
    },
    {
      name: 'titleAr',
      label: `${t('T_enter_name')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_title')} ${t('T_in_arabic')}`,
      internalLabel: true,
      required: true
    },
    {
      name: 'workshopEvaluationQuestionDimensionId',
      label: t('T_dimension'),
      type: InputTypes.SELECT,
      placeholder: t('T_dimension'),
      options: dimensionsOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
    {
      name: 'description',
      label: t('T_enter_description'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_description'),
      internalLabel: true,
      required: true
    },
    {
      name: 'descriptionAr',
      label: `${t('T_enter_description')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_enter_description')} ${t('T_in_arabic')}`,
      internalLabel: true,
      required: true
    },
    {
      name: 'questionOrder',
      label: t('T_order'),
      type: InputTypes.NUMBER,
      placeholder: t('T_enter_order'),
      internalLabel: true,
      required: true
    },
    {
      name: 'type',
      label: t('T_type'),
      type: InputTypes.SELECT,
      placeholder: t('T_select_type'),
      options: typesOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_add_question')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default AddWorkshopEvaluationQuestion;
